import useTranslation from 'next-translate/useTranslation';
import { INSTAGRAM, PINTEREST, TIKTOK, TIKTOK_BUSINESS, TWITTER } from '@/lib/socialProfile';

// Hooks
import { useAlbumContext } from '@/utils/hooks/context/useAlbumContext';
import useActiveSocialProfile from '@/utils/hooks/user/useActiveSocialProfile';

// Components
import Icon from '@/components/base/Icon';
import Label from '@/components/base/Label';
import SelectPostType from '@/components/pages/albums/AlbumFunnelModal/components/SelectPostType';

const PostTypeFilter = () => {
    const { t } = useTranslation('content');
    const { albumInfo } = useAlbumContext();
    const { activeSocialProfile } = useActiveSocialProfile();
    const network = activeSocialProfile?.social_network_type;

    const initialOptions = albumInfo?.criteria?.post_types?.map((type) => ({
        label: type,
        value: type
    }));

    if (network === TIKTOK || network === TIKTOK_BUSINESS) {
        return null;
    }

    function getLabel() {
        switch (network) {
            case INSTAGRAM:
                if (albumInfo?.criteria?.album_type === 'stories') {
                    return {
                        iconLabel: 'story',
                        textLabel: 'content:modal.story_type'
                    };
                }
                return {
                    iconLabel: 'content',
                    textLabel: 'content:modal.post_type'
                };
            case PINTEREST:
                return {
                    iconLabel: 'content',
                    textLabel: 'content:modal.pin_type'
                };
            case TWITTER:
                return {
                    iconLabel: 'content',
                    textLabel: 'content:modal.tweet_type'
                };
            default:
                return {
                    iconLabel: 'content',
                    textLabel: 'content:modal.post_type'
                };
        }
    }

    const { iconLabel, textLabel } = getLabel();

    return (
        <div>
            <Label className="flex items-center space-x-2.5 pb-2">
                <Icon icon={iconLabel} className="text-sm text-icoBlue" />
                <span className="text-icoBlack dark:text-white">{t(textLabel)}</span>
            </Label>
            <SelectPostType
                leadingIcon={false}
                variant="auto"
                initialOptions={initialOptions?.length ? initialOptions : null}
            />
        </div>
    );
};

PostTypeFilter.propTypes = {};

export default PostTypeFilter;
